import officeApiIsRequirementSetSupported from './office-api-is-requirement-set-supported'
import officeApiIsAsyncMethodSupported from './office-api-is-async-method-supported'

export default async function officeApiCallAsync<T>(requirementSet: string, apiMethodName: any, officeMethodAsync: () => Promise<T>): Promise<T> {
  if (!officeApiIsRequirementSetSupported(requirementSet)) {
    throw new Error('Unsupported Requirement Set - ' + apiMethodName)
  } else if (!officeApiIsAsyncMethodSupported(apiMethodName)) {
    throw new Error('Unsupported OfficeJs Method - ' + apiMethodName)
  } else {
    const timeoutPromise = new Promise<T>((resolve, reject) =>
      setTimeout(() => {
        reject(new Error('Office Async Timeout - ' + apiMethodName))
      }, 10000),
    )

    return await Promise.race([officeMethodAsync(), timeoutPromise])
  }
}
